'use client'

import * as React from 'react'

export const TeamDashboardHrefContext = React.createContext<string | null>(null)

export function useTeamDashboardHref() {
  return React.useContext(TeamDashboardHrefContext)
}
